<template>
  <div class="loader-container">
    <span class="loader2"></span>
    <span class="blinking">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "Spinner",
};
</script>

<style></style>
